<vp-header
	[editableInStoryblok]="_editable()"
	[hideMenu]="hideMenu()"
	[menuItems]="headerMenu()"
	[metaMenu]="metaMenu()"
	[title]="hotelStore.slug() || title()"
	[variant]="variant"
	(languageSwitch)="onLanguageSwitch($event)"
/>
